export const TEAM_NAME = 'growth-artemis';
export const PACKAGE_NAME = 'jiraTrialAssistant';
export const ANALYTICS_SOURCE_NAME = 'jiraTrialAssistant';
export const ROVO_AGENT_CONFIG_ID = 'jira_trial_guide_agent';
export type TrialAssistantSource = 'jira-trial-welcome-modal' | 'jira-trial-reminder-spotlight';

export const ROVO_TRIAL_GUIDE_AGENT_CONFIG = {
	name: 'Test Chat with Jira Trial Assistant',
	dialogues: [],
	agentExternalConfigReference: ROVO_AGENT_CONFIG_ID,
};

export const ROVO_DEFAULT_AGENT_CONFIG = {
	name: 'Test Chat with Jira Trial Assistant',
	dialogues: [],
};
